<template>
  <footer class="bg-dark py-5">
    <b-container>   </b-container>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  /*props: {
    msg: String,
  },*/
};
</script>


<style scoped>
footer {
  height: 25vh;
  color: white;
}
</style>